import { render, staticRenderFns } from "./NgSelectMulti.vue?vue&type=template&id=5b245c86"
import script from "./NgSelectMulti.vue?vue&type=script&lang=js"
export * from "./NgSelectMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports